import { render, staticRenderFns } from "./NonAuthHeader.vue?vue&type=template&id=a894c6a0&"
import script from "./NonAuthHeader.vue?vue&type=script&lang=js&"
export * from "./NonAuthHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports